import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  public languages: string[] = ['en', 'es', 'de', 'it', 'ru', 'fr'];

  constructor(public translate: TranslateService, private cookieService: CookieService) {

    let browserLang: any;
    /**
     * cookie Language Get
    */
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      browserLang = translate.getBrowserLang();
    }

    const normalizedLang = this.normalizeLanguage(browserLang);
    this.translate.use(normalizedLang);
    this.cookieService.set('lang', normalizedLang);
  }

  /**
   * Cookie Language set
   */
  public setLanguage(lang: any) {
    const normalizedLang = this.normalizeLanguage(lang);
    this.translate.use(normalizedLang);
    this.cookieService.set('lang', normalizedLang);
  }

  private normalizeLanguage(lang: unknown): string {
    if (typeof lang !== 'string' || lang.trim() === '') {
      return 'fr';
    }

    const normalized = lang.trim().toLowerCase().replace('_', '-');
    const baseLang = normalized.split('-')[0];

    return this.languages.includes(baseLang) ? baseLang : 'fr';
  }

}
